'use client'

import { useEffect, useRef } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import { tracking } from '@/tracking'

export function NotFoundAnalyticsTracker() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const search = searchParams.toString()
  const lastTrackedUrlRef = useRef<string | null>(null)

  useEffect(() => {
    const path = pathname || window.location.pathname
    const searchWithPrefix = search ? `?${search}` : ''
    const pagePath = `${path}${searchWithPrefix}`
    const pageLocation = window.location.href

    if (lastTrackedUrlRef.current === pageLocation) return
    lastTrackedUrlRef.current = pageLocation

    tracking.track(
      'Page not found',
      {
        error_code: 404,
        page_path: pagePath,
        page_location: pageLocation,
        page_referrer: document.referrer || undefined,
        page_title: document.title,
      },
      {
        eventId: `404:${pageLocation}`,
        replayOnConsent: true,
      }
    )
  }, [pathname, search])

  return null
}
